// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gdSPS","avatar":"styles_avatar__EeGZ_"};